'use client';

import { FC, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { MyListing } from '@/hotdesk-ui/services/listing.service';
import { LanguageCode } from '@/hotdesk-ui/constants/langulage.constant';
import CarouselSection from '@/hotdesk-ui/components/shared/CarouselSection';
import WorkspaceListings from '@/hotdesk-ui/components/popup/workspace-listing/WorkspaceListings';
import styles from './InactiveListingView.module.scss';
export interface InactiveListingViewProps {
  listing: MyListing;
  similarListings: MyListing[];
  otherWorkspaceListings: MyListing[];
  workspaceListingCount: number;
  languageCode: LanguageCode;
}
const InactiveListingView: FC<InactiveListingViewProps> = ({
  listing,
  similarListings,
  otherWorkspaceListings,
  workspaceListingCount,
  languageCode
}) => {
  const t = useTranslations('workspace-details');
  const router = useRouter();
  const [countdown, setCountdown] = useState(10);
  const [workspaceListingsPopup, setWorkspaceListingsPopup] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const filteredSimilarListings = similarListings.slice(0, 10);
  const hasAnyListings = otherWorkspaceListings.length > 0 || filteredSimilarListings.length > 0;
  useEffect(() => {
    if (!hasAnyListings) {
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            handleExploreMore();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [hasAnyListings]);
  const handleExploreMore = () => {
    router.push('/workspaces');
  };
  return <div className={styles.page} data-sentry-component="InactiveListingView" data-sentry-source-file="InactiveListingView.tsx">
            <div className={styles.container}>
                <div className={styles.iconWrapper}>
                    <img src="/assets/icons/inactive-workspace.svg" alt="inactive-listing" />
                </div>

                <div className={styles.content}>
                    <h1 className={styles.title}>
                        {t('listing_currently_inactive')}
                    </h1>
                    <h2 className={styles.subtitle}>
                        {t('listing_notified_message')}
                    </h2>

                    <p className={styles.description}>
                        {t('explore_available_workspaces')}
                    </p>
                </div>

                {otherWorkspaceListings.length > 0 && <div className={styles.similarSection}>
                        <CarouselSection title={t('otherListingsInWorkspace')} listings={otherWorkspaceListings as any} variant="listing" showBookNow workspaceListingCount={workspaceListingCount} onWorkspacesClick={() => setWorkspaceListingsPopup({
          id: listing?.workspace?.id || 0,
          name: listing?.workspace?.title || ''
        })} />
                    </div>}

                {filteredSimilarListings.length > 0 ? <div className={styles.similarSection}>
                        <CarouselSection title={t('similarListings')} listings={filteredSimilarListings as any} variant="listing" showBookNow />
                    </div> : !hasAnyListings && <p className={styles.redirectMessage}>
                            {t('redirecting_message')}
                            <span className={styles.countdown}>{countdown}</span>
                            {t('redirecting_seconds')}
                        </p>}

                <button type="button" className={styles.exploreButton} onClick={handleExploreMore}>
                    {t('explore_more')}
                </button>
            </div>

            {workspaceListingsPopup && <WorkspaceListings showPopup={!!workspaceListingsPopup} workspaceId={workspaceListingsPopup.id} workspaceName={workspaceListingsPopup.name} languageCode={languageCode} onClose={() => setWorkspaceListingsPopup(null)} showBookNow />}
        </div>;
};
export default InactiveListingView;